var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"InlineChargingpoint"},[_c('img',{staticClass:"d-inline mr-1",attrs:{"width":"15","src":_vm.icon}}),_vm._v(" "+_vm._s(`${_vm.id}: ${_vm.address || _vm.remark || _vm.statusLabel}`)+" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }